export default __webpack_public_path__ + "e28be70d9251468c5bf7b51bbd5df59d.svg";